<div class="uk-position-center ">
  <div class="cssload-thecube">
    <div class="cssload-cube cssload-c1 background-primary-before"></div>
    <div class="cssload-cube cssload-c2 background-primary-before"></div>
    <div class="cssload-cube cssload-c4 background-primary-before"></div>
    <div class="cssload-cube cssload-c3 background-primary-before"></div>
  </div>
</div>
